<template>
  <div
    v-if="footerConfig"
    id="dynamic-footer-wrap"
    :style="{
      backgroundColor: colors.background,
      color: colors.text_color,
    }"
  >
    <div class="dynamic-footer">
      <div
        v-if="logosEnabled && logos.length > 0"
        class="logos"
        :class="{ 'no-padding': logoLayoutStyle === 'grid' }"
      >
        <div class="grid-display" v-if="logoLayoutStyle === 'grid'">
          <div
            v-for="(logoRow, index) in logos"
            :key="`logo-${index}`"
            class="grid-row"
          >
            <img
              v-for="(logo, imgIndex) in logoRow"
              :key="`logoRow-${imgIndex}`"
              :style="setGridLogoStyles(imgIndex, logoRow.length)"
              :src="logo.src"
              alt="company-logo"
              @click="openLink(logo.url)"
            />
          </div>
        </div>
        <VueSlickCarousel
          v-else-if="logoLayoutStyle === 'carousel'"
          v-bind="settings"
        >
          <img
            v-for="(logo, index) in logos"
            :key="`carousel-${index}`"
            :src="logo.src"
            alt="company-logo"
            @click="openLink(logo.url)"
          />
          <template #prevArrow>
            <img class="custom-arrow" :src="$images.carouselArrow" />
          </template>
          <template #nextArrow>
            <img class="custom-arrow reverse" :src="$images.carouselArrow" />
          </template>
        </VueSlickCarousel>
      </div>
      <div class="columns-wrap">
        <!-- <div class="native-logo">
          <img :src="$images.bsb_logo" alt="logo.png" />
        </div> -->
        <div class="columns">
          <div
            v-for="(col, index) in columns"
            :key="`col-${index}`"
            class="column"
          >
            <div class="title">{{ col.title }}</div>
            <div v-html="col.text" class="content"></div>
            <!-- v-if="col.type === 'html'" -->
            <!-- <div
              v-else
            >
              {{ col.text}}
            </div> -->
          </div>
        </div>
      </div>
      <div class="footers-footer" :class="{'active': logos.length > 0 && logosEnabled && columns.length > 0}">
        <div class="links-social">
          <div class="links">
            <a
              v-for="(link, index) in links"
              :key="`link-${index}`"
              :href="link.url"
              target="_blank"
            >
              {{ link.label }}
            </a>
          </div>
          <div class="social">
            <div class="bug" v-if="reportBug.enabled">
              <a
                :href="reportBug.url"
                :class="{ 'no-social': socialMedia.medias.length === 0 }"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                >
                  <path
                    :fill="colors.icon_color"
                    d="M6.46393 6.01562H7.65465C7.7482 6.01562 7.82475 5.93828 7.82475 5.84375C7.82475 5.23574 7.9502 4.70078 8.18835 4.26465C8.41373 3.84785 8.74118 3.51699 9.15368 3.28926C9.58744 3.05078 10.1148 2.92188 10.7165 2.92188H11.0567C11.6584 2.92188 12.1879 3.04863 12.6195 3.28926C13.032 3.51699 13.3595 3.84785 13.5849 4.26465C13.8209 4.70293 13.9485 5.23574 13.9485 5.84375C13.9485 5.93828 14.025 6.01562 14.1186 6.01562H15.3093C15.4028 6.01562 15.4794 5.93828 15.4794 5.84375C15.4794 4.98438 15.2923 4.1959 14.9287 3.52129C14.563 2.84453 14.025 2.30098 13.3552 1.93145C12.6876 1.56406 11.9072 1.375 11.0567 1.375H10.7165C9.86599 1.375 9.08564 1.56406 8.41799 1.93145C7.7482 2.30098 7.21025 2.84453 6.84453 3.52129C6.48094 4.1959 6.29382 4.98438 6.29382 5.84375C6.29382 5.93828 6.37037 6.01562 6.46393 6.01562Z"
                  />
                  <path
                    :fill="colors.icon_color"
                    d="M19.9871 11H16.8402V8.85156C18.4732 8.85156 19.7957 7.51523 19.7957 5.86523C19.7957 5.7707 19.7192 5.69336 19.6256 5.69336H18.3499C18.2563 5.69336 18.1798 5.7707 18.1798 5.86523C18.1798 6.61289 17.5801 7.21875 16.8402 7.21875H4.93298C4.19303 7.21875 3.59342 6.61289 3.59342 5.86523C3.59342 5.7707 3.51687 5.69336 3.42331 5.69336H2.14754C2.05398 5.69336 1.97744 5.7707 1.97744 5.86523C1.97744 7.51523 3.29999 8.85156 4.93298 8.85156V11H1.78607C1.69251 11 1.61597 11.0773 1.61597 11.1719V12.375C1.61597 12.4695 1.69251 12.5469 1.78607 12.5469H4.93298V14.6094C4.93298 14.749 4.93723 14.8887 4.94786 15.024C3.48923 15.6535 2.46648 17.1166 2.46648 18.8203C2.46648 18.9148 2.54303 18.9922 2.63659 18.9922H3.82731C3.92086 18.9922 3.99741 18.9148 3.99741 18.8203C3.99741 17.8707 4.50559 17.0393 5.26468 16.5924C5.39226 16.9619 5.55385 17.3143 5.74734 17.6451C6.26403 18.5367 7.00185 19.2822 7.88426 19.8043C8.76667 20.3264 9.79155 20.625 10.8866 20.625C11.9816 20.625 13.0086 20.3264 13.891 19.8043C14.7734 19.2822 15.5113 18.5367 16.0279 17.6451C16.2214 17.3121 16.383 16.9598 16.5106 16.5924C17.2676 17.0393 17.7758 17.8707 17.7758 18.8203C17.7758 18.9148 17.8523 18.9922 17.9459 18.9922H19.1366C19.2301 18.9922 19.3067 18.9148 19.3067 18.8203C19.3067 17.1166 18.2839 15.6535 16.8253 15.024C16.8338 14.8865 16.8402 14.749 16.8402 14.6094V12.5469H19.9871C20.0807 12.5469 20.1572 12.4695 20.1572 12.375V11.1719C20.1572 11.0773 20.0807 11 19.9871 11ZM15.2242 14.6094C15.2242 15.4 15.018 16.1563 14.6331 16.8201C14.2568 17.4711 13.7188 18.0146 13.0745 18.3949C12.4175 18.7838 11.6691 18.9922 10.8866 18.9922C10.1041 18.9922 9.35566 18.7838 8.69863 18.3949C8.05437 18.0146 7.51642 17.4711 7.14006 16.8201C6.75521 16.1563 6.54896 15.4 6.54896 14.6094V8.85156H15.2242V14.6094Z"
                  />
                </svg>
                {{ reportBug.label }}
              </a>
            </div>
            <div>
              <span v-if="socialMedia.medias.length > 0">
                {{ socialMedia.label }}
              </span>
              <svg
                v-for="(media, index) in socialMedia.medias"
                :key="`media-${index}`"
                :width="media.width"
                :height="media.height"
                :viewBox="media.viewBox"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                @click="openLink(media.link)"
              >
                <path :fill="colors.icon_color" :d="media.d" />
              </svg>
            </div>
          </div>
        </div>
        <div class="copyright-mars">
          <div class="rights">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                :fill="colors.text_color"
                d="M7 0C3.13438 0 0 3.13438 0 7C0 10.8656 3.13438 14 7 14C10.8656 14 14 10.8656 14 7C14 3.13438 10.8656 0 7 0ZM7 12.8125C3.79063 12.8125 1.1875 10.2094 1.1875 7C1.1875 3.79063 3.79063 1.1875 7 1.1875C10.2094 1.1875 12.8125 3.79063 12.8125 7C12.8125 10.2094 10.2094 12.8125 7 12.8125ZM7.0875 4.48906C7.91562 4.48906 8.47812 5.01719 8.54062 5.79219C8.54531 5.85781 8.6 5.90781 8.66562 5.90781H9.55156C9.59219 5.90781 9.625 5.875 9.625 5.83437C9.625 4.47969 8.55625 3.53125 7.08281 3.53125C5.36562 3.53125 4.375 4.69062 4.375 6.60625V7.42344C4.375 9.325 5.36562 10.4688 7.08281 10.4688C8.55156 10.4688 9.625 9.55 9.625 8.25937C9.625 8.21875 9.59219 8.18594 9.55156 8.18594H8.66406C8.59844 8.18594 8.54531 8.23594 8.53906 8.3C8.47344 9.02031 7.9125 9.51562 7.08594 9.51562C6.06563 9.51562 5.49062 8.76719 5.49062 7.42813V6.60625C5.49219 5.24687 6.06875 4.48906 7.0875 4.48906Z"
              />
            </svg>
            <span>{{ copyrightText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import socialMediaSvgs from './socialMediaSvgs'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: {
    VueSlickCarousel,
  },
  props: {
    footerConfig: {
      type: Object,
    },
  },
  data() {
    return {
      innerWidth: window.innerWidth,
    }
  },
  computed: {
    ...mapState(['FOOTER_URL_PREFIX']),
    settings() {
      const carouselSettings = {
        infinite: true,
        centerPadding: '50px',
        slidesToScroll: 1,
        variableWidth: true,
        speed: 500,
        arrows: false,
      }

      carouselSettings.speed =
        parseInt(this.footerConfig.partner_logos.carus_speed) * 200
      carouselSettings.arrows = this.footerConfig.partner_logos.carus_control
      carouselSettings.autoplay = this.footerConfig.partner_logos.carus_auto
      carouselSettings.slidesToShow =
        parseInt(this.footerConfig.partner_logos.carus_visible) || 1
      if (this.innerWidth < 1000 && carouselSettings.slidesToShow > 3)
        carouselSettings.slidesToShow = 3
      if (this.innerWidth < 600 && carouselSettings.slidesToShow > 2)
        carouselSettings.slidesToShow = 2
      if (this.innerWidth < 400 && carouselSettings.slidesToShow > 1)
        carouselSettings.slidesToShow = 1

      return carouselSettings
    },
    colors() {
      return this.footerConfig.color
    },
    links() {
      return this.footerConfig.pre_copyright_navigation.value
    },
    columns() {
      const columns = []
      for (const key in this.footerConfig.columns) {
        const col = this.footerConfig.columns[key]
        const isColNotEmpty = Object.keys(col).length > 0
        if (isColNotEmpty) columns.push(col)
      }
      return columns
    },
    socialMedia() {
      const smObj = {
        label: this.footerConfig.social_media.label,
        medias: [],
      }
      for (const key in this.footerConfig.social_media) {
        if (key === 'label') continue

        // if no url is provided for social media network, skip it
        // urls can contain "https://" so we need to check for it, then strip it
        const rawUrl = this.footerConfig.social_media[key]
        const parsedUrl = rawUrl.includes(this.FOOTER_URL_PREFIX)
          ? rawUrl.slice(this.FOOTER_URL_PREFIX.length)
          : rawUrl

        if (parsedUrl.length > 0) {
          smObj.medias.push({
            ...socialMediaSvgs[key],
            link: parsedUrl,
          })
        }
      }
      return smObj
    },
    reportBug() {
      return this.footerConfig.report_a_bug
    },
    logos() {
      // logos array will be of different structure depending on logos layout style
      let logos = []

      if (this.logoLayoutStyle === 'carousel') {
        logos = this.footerConfig.partner_logos.data.map((logoObj) => ({
          ...logoObj,
          src: `${process.env.VUE_APP_API_URL}/footer/image/${logoObj.image}`,
        }))
      }
      if (this.logoLayoutStyle === 'grid') {
        // making array of arrays to control how many logos are displayed per row
        const itemsPerRowCount = this.footerConfig.partner_logos.grid_row || 1
        const logosCount = this.footerConfig.partner_logos.data.length
        const rowCount = Math.ceil(logosCount / itemsPerRowCount)
        for (let i = 0; i < rowCount; i++) {
          const logoRow = this.footerConfig.partner_logos.data.slice(
            itemsPerRowCount * i,
            itemsPerRowCount * (i + 1),
          )
          const logoRowFormatted = logoRow.map((logoObj) => ({
            ...logoObj,
            src: `${process.env.VUE_APP_API_URL}/footer/image/${logoObj.image}`,
          }))

          logos.push([...logoRowFormatted])
        }
      }

      return logos
    },
    logoLayoutStyle() {
      // return 'carousel';
      return this.footerConfig.partner_logos.layout || 'carousel'
    },
    copyrightText() {
      return this.footerConfig.copyright_line.value
    },
    logosEnabled() {
      return !!this.footerConfig.partner_logo_enabled.value
    },
  },
  watch: {
    footerConfig: {
      deep: true,
      handler(isNotNull) {
        if (isNotNull && this.logoLayoutStyle === 'carousel')
          this.setCarouselLogoSpacing()
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.logoLayoutStyle === 'carousel') {
        this.setCarouselLogoSpacing()

        window.addEventListener('resize', () => {
          this.innerWidth = window.innerWidth
          //TODO maybe improve this to not be called while resizing
          this.setCarouselLogoSpacing()
        })
      }
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    setGridLogoStyles(imgIndex, logoRowLength) {
      const spacing = parseInt(this.footerConfig.partner_logos.grid_gap) || 0

      const style = {
        margin: `0 ${spacing / 2}px`,
      }

      if (imgIndex === 0) {
        style.marginLeft = 0
      }
      if (imgIndex === logoRowLength - 1) {
        style.marginRight = 0
      }

      return style
    },
    setCarouselLogoSpacing() {
      // need to manipulate the library dom
      const spacing = parseInt(this.footerConfig.partner_logos.carus_gap) || 0
      const slideEls = document.querySelectorAll('.slick-slide')
      slideEls.forEach((el) => (el.style.margin = `0 ${spacing / 2}px`))
    },
  },
}
</script>

<style lang="scss" scoped>
#dynamic-footer-wrap {
  $carousel-arrow-spacing: -65px;
  padding: 50px MIN(350px, 15vw);
  * {
    color: inherit;
    font-family: 'Roboto';
  }
  .dynamic-footer {
    .logos {
      padding: 0 abs($carousel-arrow-spacing);
      margin-bottom: 70px;
      min-height: 50px;
      &.no-padding {
        padding: 0;
      }
      .grid-display {
        display: flex;
        flex-direction: column;
        .grid-row {
          display: flex;
          align-items: center;
          img {
            min-width: 50px;
            min-height: 50px;
          }
        }
      }
      img {
        cursor: pointer;
      }
    }
    .columns-wrap {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      // margin-bottom: 15px;
      // .native-logo {
      //   margin-right: MIN(150px, 8vw);
      //   margin-bottom: 15px;
      //   img {
      //     display: block;
      //     width: 200px;
      //   }
      // }
      .columns {
        display: flex;
        flex-grow: 1;
        .column {
          flex: 1 1 0px;
          margin: 0 auto;
          .title {
            font-weight: 600;
          }
        }
      }
    }
    .footers-footer {
      padding: 25px 0;
      &.active {
        border-top: 1px solid #e5e5e5;
      }
      .links-social {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 20px;
        font-weight: 600;
        .links {
          display: flex;
          > a {
            margin: 0 8px;
            cursor: pointer;
            &:first-child {
              margin-left: 0;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .social {
          display: flex;
          .bug {
            a {
              display: flex;
              margin-right: 48px;
              &.no-social {
                margin-right: 0;
              }
              svg {
                margin-right: 10px;
              }
            }
          }
          div {
            display: flex;
            align-items: center;
            > svg {
              display: flex;
              align-items: center;
              margin: 0 8px;
              cursor: pointer;
              &:first-child {
                margin-left: 0;
              }
              &:last-child {
                margin-right: 0;
              }
            }
          }
        }
      }
      .copyright-mars {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .rights {
          display: flex;
          align-items: center;
          svg {
            margin-right: 10px;
            margin-bottom: 1px;
            width: 14px;
          }
        }
      }
    }
  }
  .custom-arrow {
    width: auto;
    height: auto;
    left: $carousel-arrow-spacing;
    &::before {
      content: '';
    }
    &.reverse {
      // gotta include translate as well because the library already has transform property for this element
      transform: translate(0, -50%) rotate(180deg);
      left: auto;
      right: $carousel-arrow-spacing;
    }
  }
}
</style>

<style lang="scss">
#dynamic-footer-wrap {
  .slick-track {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
